import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, AfterViewInit, AfterContentChecked } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { InfoBoxComponent } from '../../utility/info-box/info-box.component';
import { AppointmentStepperService } from '../../../services/appointment-stepper.service';
import { AccountDataDTO, RelatedProfileDTO, UserAccountDTO, UsersAccountDTO } from '../../../classes/user-account.dto';
import { StorageService } from '../../../services/storage.service';
import { HttpService } from '../../../services/http.service';
import { Router } from '@angular/router';
import { DataService } from '../../../services/data.service';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ModalCreateProfileComponent } from '../../modals/modal-create-profile/modal-create-profile.component';
import { NzRadioGroupAccessibilityDirective } from '../../../directives/nz-radio-group-accessibility.directive';

@Component({
    selector: 'app-profile-selection-care-manager',
    imports: [NzRadioModule, NzRadioGroupAccessibilityDirective, ReactiveFormsModule, NzDividerModule, NzIconModule, TranslateModule, InfoBoxComponent],
    templateUrl: './profile-selection-care-manager.component.html',
    styleUrl: './profile-selection-care-manager.component.scss'
})
export class ProfileSelectionCareManagerComponent implements OnInit, AfterContentChecked, OnDestroy {
  private destroy$ = new Subject<void>();
  @Input({ required: true }) profiles: any;
  @Input() typeAppointment: string = '';
  @Output() emitNewProfile: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() profileEmitter: EventEmitter<UsersAccountDTO | RelatedProfileDTO> = new EventEmitter<UsersAccountDTO | RelatedProfileDTO>();
  profileSelected: FormControl<UsersAccountDTO | RelatedProfileDTO> = new FormControl();
  subscriptions: Array<Subscription> = [];

  constructor(
    private appointmentStepperService: AppointmentStepperService,
    private storage: StorageService,
    private http: HttpService,
    private router: Router,
    private dataService: DataService,
    private modal: NzModalService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.profileSelected.valueChanges.subscribe((profile: UsersAccountDTO | RelatedProfileDTO): void => {
        this.profileEmitter.emit(profile);
      })
    );
    const oldValues = this.appointmentStepperService.getMainUser();
    if (oldValues) {
      this.profileSelected.patchValue(oldValues);
    }
  }

  ngAfterContentChecked() {
    this.setMainUser();
  }

  private setMainUser() {
    if (this.profiles && this.profiles.relatedProfiles.length === 0) {
      this.profileSelected.patchValue(this.profiles);
    }
  }

  protected createProfile(): void {
    const modalRef: NzModalRef<ModalCreateProfileComponent> = this.modal.create({
      nzContent: ModalCreateProfileComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: {
          actionButton: () => {
            this.emitNewProfile.emit(true);
            modalRef.close();
          },
        },
      },
    });
    modalRef.afterClose.subscribe((result): void => {
      console.log(result);
    });
  }

  public switchProfile(user: any) {
    if (user) {
      const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
      const oldUserData = JSON.parse(this.storage.getItem('oldUserData')!) as UserAccountDTO;
      if (oldUserData && oldUserData.individualId === user.value.individualId) {
        this.http
          .getAccountdDataNoConnectionValidations(user?.value.individualId)
          .pipe(takeUntil(this.destroy$))
          .subscribe((accountData: AccountDataDTO) => {
            this.dataService.setAccountDataFrom(false);
            this.storage.setItem('userData', oldUserData);
            this.dataService.setAccountData(accountData);
            this.storage.removeItem('oldUserData');
            this.router.navigate(['/personal-area/your-data']);
          });
      } else if (user.value.individualId === userData.individualId) {
        this.router.navigate(['/personal-area/your-data']);
      } else {
        this.http
          .getAccountdDataNoConnectionValidations(user?.value.individualId)
          .pipe(takeUntil(this.destroy$))
          .subscribe((accountData: AccountDataDTO) => {
            this.dataService.setAccountData(accountData);
            this.dataService.setAccountDataFrom(true);
            const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
            var data = { ...accountData.customer };
            data.functions = accountData.functions;
            this.storage.setItem('oldUserData', userData);
            this.storage.setItem('userData', data);
            this.router.navigate(['/personal-area/your-data']);
          });
      }
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this.destroy$.next();
    this.destroy$.complete();
  }
}
